import camelCase from 'lodash/camelCase';
import { Vibrant } from 'node-vibrant/browser';

export async function getPalette(imageSrc) {
  const image = new Image();
  const imageUrl = new URL(imageSrc, window.location.href);

  // Prevents the browser's cached image-sans-CORS response from being used
  imageUrl.searchParams.set('vibrant', '1');
  image.crossOrigin = 'anonymous';
  image.src = imageUrl.toString();

  const vibrant = new Vibrant(image);
  const palette = await vibrant.getPalette();
  const setPaletteColor = (acc, paletteName) => ({
    ...acc,
    [camelCase(paletteName)]: palette[paletteName]?.hex,
  });

  return Object.keys(palette).reduce(setPaletteColor, {});
}
